import { useHubApi } from 'api/hubs/queries/useHubApi'
import { useHubId } from 'pages/hubs/utils'
import { HubType } from 'types/hubs/hubs'

export const useCurrentHubData = () => {
  const hubId = useHubId()
  const {
    isLoading,
    data: hub,
    error,
  } = useHubApi({
    params: {
      hubId: hubId!,
    },
    enabled: !!hubId,
  })
  const isCustomHub = hub?.type === HubType.Custom
  return {
    isLoading,
    hub,
    isCustomHub,
    error,
  }
}
